// extracted by mini-css-extract-plugin
export default {"usageDetails":"DonutChartWithLabel_usageDetails__RtcjK","expiryDate":"DonutChartWithLabel_expiryDate__gj8xt","chartDetails":"DonutChartWithLabel_chartDetails__kt2w6"};